import { I18nText } from '../types';

const createI18nText = <T extends object>(text: I18nText<T>) => {
	return text;
}

export default createI18nText;